<template>
  <button
    class="flex py-[12px] w-full font-bold items-center select-none justify-center hover:shadow-sm hover:cursor-pointer rounded-lg px-[16px] disabled:bg-primary-3 disabled:hover:cursor-not-allowed"
    :class="[buttonClasses, { 'opacity-50': props.disabled }]"
    @click.stop.prevent="buttonClicked"
  >
    <Spinner v-if="props.loading" />
    <slot v-else />
  </button>
</template>

<script setup>
import { computed } from 'vue'
import Spinner from '@/components/loading/Spinner.vue'
import { isKids, isPets } from '@/comp/AppType'

const props = defineProps({
  disabled: {
    type: Boolean,
    required: false,
    default: false
  },
  loading: {
    type: Boolean,
    required: false,
    default: false
  },
  outline: {
    type: Boolean,
    required: false,
    default: false
  }
})

const emit = defineEmits(['click'])

const buttonClasses = computed(() => {
  if (isKids.value) {
    if (props.outline) return 'bg-white border-primary-0 border text-primary-0'
    return 'bg-primary-0 text-white'
  } else if (isPets.value) {
    if (props.outline) return 'bg-white border-pets-primary-1 border text-pets-primary-1'
    return 'bg-pets-primary-1 text-white'
  } else {
    if (props.outline)
      return 'bg-white border-guardian-secondary-0 border text-guardian-secondary-0'
    return 'bg-guardian-secondary-0 text-white'
  }
})

const buttonClicked = () => (props.disabled || props.loading ? null : emit('click'))
</script>
